import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { environment } from '@env';
import { AuthStatus, LoginResponse, User } from '../interfaces';
import { Observable, catchError, map, throwError } from 'rxjs';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly baseUrl: string = environment.apiResrURL;
  private readonly usuariosUrl: string = `${this.baseUrl}/sgi-usuarios`;

  private http = inject(HttpClient);

  private _currentUser = signal<User | null>(null);
  private _authStatus = signal<AuthStatus>(AuthStatus.checking);

  //! Al mundo exterior
  public currentUser = computed(() => this._currentUser());
  public authStatus = computed(() => this._authStatus());

  constructor(private tokenService: TokenService) {}

  private setAuthentication(token: string): boolean {
    this.tokenService.setToken(token);
    this._authStatus.set(AuthStatus.authenticated);

    return true;
  }

  login(username: string, password: string): Observable<any> {
    const body = { username, password };

    return this.http.post<LoginResponse>(`${this.usuariosUrl}/auth/login`, body);
  }
}
